export default "<form>\r\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\r\n</form>\r\n"